import {
  CardJob,
  CardJobDivided,
  CardJobRec,
  CardCompanyJob,
} from '@/src/component/superstack/jobs/cards/CardJob';
import styles from '@/styles/superstack/jobs/CardList.module.scss';
import classNames from 'classnames/bind';
import useRecommendJobs from '@/src/utils/hooks/superstack/useRecommendJobs';
import FadeLoader from 'react-spinners/FadeLoader';

const CardJobList = ({
  jobs,
  handleClick,
  selectedJob,
  isSaved = false,
  showEmpty = false,
  deleteLike = null,
  isMobile = false,
  ...props
}) => {
  const cx = classNames.bind(styles);
  return (
    <>
      {showEmpty && (
        <article className={cx('empty-result-box')}>
          <p className={cx('title')}>결과가 없습니다.</p>
          <ul style={{ listStyleType: 'disc', marginTop: '20px' }}>
            <li>필터를 다시 설정하거나, 필터 개수를 줄여보세요.</li>
            <li>단어의 철자가 정확한지 확인해 보세요.</li>
            <li>한글을 영어로 혹은 영어를 한글로 입력했는지 확인해 보세요.</li>
            <li>검색어의 단어 수를 줄이거나, 보다 일반적인 검색어로 다시 검색해 보세요.</li>
            <li>두 단어 이상의 검색어인 경우, 띄어쓰기를 확인해 보세요.</li>
          </ul>
        </article>
      )}
      {!showEmpty && (
        <div className={cx('card-job-list')}>
          {jobs &&
            jobs.map((job) => {
              return (
                <CardJob
                  key={job.id}
                  job={job}
                  onClick={() => {
                    handleClick(job);
                  }}
                  isSaved={isSaved}
                  deleteLike={deleteLike}
                  isMobile={isMobile}
                  isActive={job.id === selectedJob.id}
                  {...props}
                />
              );
            })}
        </div>
      )}
    </>
  );
};

const CardJobDividedList = ({
  jobs,
  handleClick,
  isSaved = false,
  showEmpty = false,
  deleteLike = null,
  isMobile = false,
  ...props
}) => {
  const cx = classNames.bind(styles);
  return (
    <section className={cx('card-job-divided-list')}>
      {showEmpty && (
        <article className={cx('empty-result-box')}>
          <p className={cx('title')}>결과가 없습니다.</p>
          <ul style={{ listStyleType: 'disc', marginTop: '20px' }}>
            <li>필터를 다시 설정하거나, 필터 개수를 줄여보세요.</li>
            <li>단어의 철자가 정확한지 확인해 보세요.</li>
            <li>한글을 영어로 혹은 영어를 한글로 입력했는지 확인해 보세요.</li>
            <li>검색어의 단어 수를 줄이거나, 보다 일반적인 검색어로 다시 검색해 보세요.</li>
            <li>두 단어 이상의 검색어인 경우, 띄어쓰기를 확인해 보세요.</li>
          </ul>
        </article>
      )}
      {!showEmpty &&
        jobs &&
        jobs.map((job) => {
          return (
            <CardJobDivided
              key={job.id}
              job={job}
              onClick={() => {
                handleClick(job);
              }}
              isSaved={isSaved}
              deleteLike={deleteLike}
              isMobile={isMobile}
              {...props}
            />
          );
        })}
    </section>
  );
};

const CardJobRecommendList = ({ jobId, n = null, ...props }) => {
  const cx = classNames.bind(styles);
  const { data: { data: jobs = [] } = {}, isLoading } = useRecommendJobs(jobId);
  const displayingJobs = n && !isLoading ? jobs.slice(0, n) : jobs;
  return (
    <section className={cx('card-job-recommend-list')} {...props}>
      <FadeLoader
        color={'gray'}
        loading={isLoading}
        cssOverride={{
          margin: '100px auto',
        }}
      />
      {displayingJobs.map((job) => {
        return <CardJobRec key={job.id} job={job} />;
      })}
    </section>
  );
};

const CardCompanyJobList = ({ jobs, n = null, ...props }) => {
  if (!jobs) {
    return null;
  }
  const cx = classNames.bind(styles);
  const displayingJobs = n ? jobs.slice(0, n) : jobs;
  return (
    <section className={cx('card-company-job-list')}>
      {displayingJobs.map((job) => {
        return <CardCompanyJob key={job.id} job={job} {...props} />;
      })}
    </section>
  );
};

export { CardJobList, CardJobDividedList, CardJobRecommendList, CardCompanyJobList };
